import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Users, Download, Trash2, Mail, Phone, Building2 } from 'lucide-react';
import api from '../../services/api';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminClients = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadClients(); }, []);

  const loadClients = async () => {
    try {
      const response = await api.get(`${API_URL}/api/admin/clients`);
      setClients(response.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const handleExport = () => {
    const token = localStorage.getItem('token');
    window.open(`${API_URL}/api/admin/clients/export?token=${token}`, '_blank');
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Excluir cliente "${name}"?`)) return;
    try {
      await api.delete(`${API_URL}/api/admin/clients/${id}`);
      setClients(clients.filter(c => c.id !== id));
    } catch (e) { alert('Erro ao excluir'); }
  };

  return (
    <AdminLayout>
      <div>
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 data-testid="clients-page-title" className="text-2xl font-bold text-gray-800">Clientes / Leads</h1>
            <p className="text-gray-600">{clients.length} cadastros</p>
          </div>
          <Button data-testid="export-clients-btn" onClick={handleExport} variant="outline" className="border-[#055509] text-[#055509]">
            <Download size={18} className="mr-2" /> Exportar Excel
          </Button>
        </div>

        <Card>
          <CardContent className="p-0">
            {loading ? (
              <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#055509]" /></div>
            ) : clients.length === 0 ? (
              <div className="text-center py-12 text-gray-500">
                <Users size={48} className="mx-auto mb-4 opacity-50" />
                <p>Nenhum cliente cadastrado ainda</p>
                <p className="text-sm mt-1">Os clientes que se cadastrarem no site aparecerão aqui</p>
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50 border-b">
                    <tr>
                      <th className="text-left px-4 py-3 text-sm font-semibold text-gray-600">Nome</th>
                      <th className="text-left px-4 py-3 text-sm font-semibold text-gray-600">Contato</th>
                      <th className="text-left px-4 py-3 text-sm font-semibold text-gray-600 hidden md:table-cell">Empresa</th>
                      <th className="text-left px-4 py-3 text-sm font-semibold text-gray-600 hidden lg:table-cell">Local</th>
                      <th className="text-left px-4 py-3 text-sm font-semibold text-gray-600 hidden lg:table-cell">Cadastro</th>
                      <th className="text-right px-4 py-3 text-sm font-semibold text-gray-600">Ações</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    {clients.map(client => (
                      <tr key={client.id} className="hover:bg-gray-50" data-testid={`client-row-${client.id}`}>
                        <td className="px-4 py-3">
                          <div className="font-medium text-gray-800">{client.name}</div>
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex flex-col gap-1">
                            <span className="text-sm text-gray-600 flex items-center gap-1"><Mail size={12} />{client.email}</span>
                            <span className="text-sm text-gray-600 flex items-center gap-1"><Phone size={12} />{client.phone}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600 hidden md:table-cell">
                          {client.company && <span className="flex items-center gap-1"><Building2 size={12} />{client.company}</span>}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600 hidden lg:table-cell">
                          {client.city && `${client.city}`}{client.state && ` - ${client.state}`}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600 hidden lg:table-cell">
                          {client.createdAt ? new Date(client.createdAt).toLocaleDateString('pt-BR') : '-'}
                        </td>
                        <td className="px-4 py-3 text-right">
                          <Button variant="ghost" size="sm" className="text-red-600 hover:text-red-700 hover:bg-red-50" onClick={() => handleDelete(client.id, client.name)}>
                            <Trash2 size={16} />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
};

export default AdminClients;
